import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { v4 as uuid } from "uuid";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { BiCopy } from "react-icons/bi";
import InputAdornment from "@material-ui/core/InputAdornment";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import { BiCopy } from "react-icons/bi";
const initialValues = {
    // text: "",
    // link: ""
    textAz: "",
    textEn: "",
    textRu: "",
};

export default function Create(props) {
    const {
        show,
        onHide,
        onCampaigns,
        skip,
        take,
        sortField,
        orderBy,
        dataItemId,

    } = props;
    const [isError, setIsError] = useState("");
    const CreateSchema = Yup.object().shape({
        // text: Yup.string().required("Notification text is required"),


        textAz: Yup.string().required("Text Az is required"),
        textEn: Yup.string().required("Text En is required"),
        textRu: Yup.string().required("Text Ru is required"),
        // link: Yup.string().required("Link is required"),'


    });

    const getInputClasses = (filedName) => {
        if (formik.touched[filedName] && formik.errors[filedName]) {
            return true;
        }
        if (formik.touched[filedName] && !formik.errors[filedName]) {
            return false;
        }

        return false;
    };

    const onPostCategoryName = (values, resetForm, setSubmitting) => {
        const categoryName = {
            // id:id,
            id: dataItemId,
            // text: values.text,
            textAz: values.textAz,
            textEn: values.textEn,
            textRu: values.textRu,

            // link: values.link,

        };
        axios
            .put(`${process.env.REACT_APP_API_URL}campaign/changeNotificationStatus`, categoryName, {
                headers: {
                    "x-requestid": uuid(),
                },
            })
            .then((res) => {
                onCampaigns(skip, take, sortField, orderBy);
                setSubmitting(false);
                resetForm();
                onHide();
                // onCampaignChoose()
            })
            .catch(
                ({
                    response: {
                        data: { message },
                    },
                }) => {
                    setIsError(message);
                }
            );
    };

    const formik = useFormik({
        initialValues,
        validationSchema: CreateSchema,
        onSubmit: (values, { resetForm, setSubmitting }) => {
            onPostCategoryName(values, resetForm, setSubmitting);
        },
    });

    useEffect(() => {
        setIsError("");
    }, [show]);


    const handleCopyText = (name) => {
        const textAz = formik.values.textAz;
        formik.setFieldValue(name, textAz);
    };




    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="edit"
            centered
            className="modal-right pr-0"
        >
            <form onSubmit={formik.handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title id="edit">Create</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-12 pl-4 pr-4">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <TextField
                                        id="textAz"
                                        label="Notification text Az"
                                        placeholder="Notification text Az"
                                        className="w-100"
                                        error={getInputClasses("textAz")}
                                        {...formik.getFieldProps("textAz")}
                                        variant="outlined"
                                        multiline
                                        rowsMax="4"
                                        margin="normal"
                                    />
                                </div>
                                {formik.touched.textAz && formik.errors.textAz ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">{formik.errors.textAz}</div>
                                    </div>
                                ) : null}

                                {isError && (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block MuiFormLabel-root Mui-error">
                                            {isError}
                                        </div>
                                    </div>
                                )}

                            </div>






                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <TextField
                                        id="textEn"
                                        label="Notification text En"
                                        placeholder="Notification text En"
                                        className="w-100"
                                        title="Copy from Text az"
                                        variant="outlined"
                                        multiline
                                        rowsMax="4"
                                        margin="normal"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment
                                                    position="end"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <BiCopy
                                                        onClick={() => handleCopyText("textEn")}
                                                        style={{ width: "17px", height: "17px", color: "grey" }}
                                                    />
                                                </InputAdornment>
                                            ),
                                        }}
                                        error={getInputClasses("textEn")}
                                        {...formik.getFieldProps("textEn")}
                                    />
                                </div>
                                {formik.touched.textEn && formik.errors.textEn ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">{formik.errors.textEn}</div>
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <TextField
                                        id="textRu"
                                        label="Notification text Ru"
                                        placeholder="Notification text Ru"
                                        className="w-100"
                                        title="Copy from Text az"
                                        variant="outlined"
                                        multiline
                                        rowsMax="4"
                                        margin="normal"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment
                                                    position="end"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <BiCopy
                                                        onClick={() => handleCopyText("textRu")}
                                                        style={{ width: "17px", height: "17px", color: "grey" }}
                                                    />
                                                </InputAdornment>
                                            ),
                                        }}
                                        error={getInputClasses("textRu")}
                                        {...formik.getFieldProps("textRu")}
                                    />
                                </div>
                                {formik.touched.textRu && formik.errors.textRu ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">{formik.errors.textRu}</div>
                                    </div>
                                ) : null}

                            </div>




                            {/* <div className="col-12 col-md-12 col-lg-12">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <TextField
                                        id="link"
                                        label="Link"
                                        placeholder="Link"
                                        className="w-100"
                                        error={getInputClasses("link")}
                                        {...formik.getFieldProps("link")}
                                    
                                    />
                                </div>
                                {formik.touched.link && formik.errors.link ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">{formik.errors.link}</div>
                                    </div>
                                ) : null}
                                {isError && (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block MuiFormLabel-root Mui-error">
                                            {isError}
                                        </div>
                                    </div>
                                )}
                            </div> */}

                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={() => onHide(false)}>
                        Close
                    </Button>
                    <Button type="submit">Send notification</Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
}
